import { render, staticRenderFns } from "./NPSFeedbackPage.vue?vue&type=template&id=fda6de8a&scoped=true"
import script from "./NPSFeedbackPage.vue?vue&type=script&lang=js"
export * from "./NPSFeedbackPage.vue?vue&type=script&lang=js"
import style0 from "./NPSFeedbackPage.vue?vue&type=style&index=0&id=fda6de8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda6de8a",
  null
  
)

export default component.exports